import { SDBreadcrumbs, SDListItem, SDProduct, SDOfferCatalog } from "./StructuredDataModels";
import { GetDomain, UrlSegments } from "../../Helpers";
import { WaitForElementToDisplay } from "../../Helpers/WaitForElementToDisplay";

export class StructuredDataModelFactory {    
    public AddSchema = (schema) => {
        var script = document.createElement('script');
        script.type = "application/ld+json";
        script.text = JSON.stringify(schema);

        document.querySelector('head').appendChild(script);
        console.debug("Schema injected: ", { schema, script });
    }

    public GenerateBreadcrumbs = (schema: SDBreadcrumbs) => {

        const makeBreadcrumbs = () => {
            // Remove top padding so we can insert the breadcrumb and not make the spacing awkward
            //var titleDiv = document.querySelector('h1').parentElement;
            //titleDiv.classList.remove('mt-3');

            var breadcrumbList = document.createElement('ul');
            breadcrumbList.className = "breadcrumb small my-0 px-0 px-lg-3";

            schema.itemListElement.forEach((listItem: SDListItem) => {

                var link = document.createElement('a');
                link.href = listItem.item["@id"];
                link.title = listItem.item.name;
                link.text = listItem.item.name;

                var crumb = document.createElement('li');
                crumb.className = "breadcrumb-item p-0 m-0";
                crumb.appendChild(link);
                breadcrumbList.appendChild(crumb);
            })

            let breadcrumbs = document.getElementById("sd-breadcrumbs");
            breadcrumbs.appendChild(breadcrumbList);

            let active = breadcrumbs.querySelector('ul').lastElementChild;
            active.classList.add('active');
            active.lastElementChild.classList.add("text-primary");
        }

        WaitForElementToDisplay('h1', 300, makeBreadcrumbs);
    }

    //public HandleProductStructuredData(ProductDetail)
    //{        
    //    if (!ProductDetail) {
    //        return;
    //    }

    //    if (!ProductDetail.Items) {
    //        return;
    //    }

    //    //not used but required param
    //    let count = 0;                     
    //    new StructuredDataModelFactory().AddSchema(new SDProduct(ProductDetail.Items[0], count));        
    //}

    public GenerateProductDetailsOfferCatalog = () => {

        if (UrlSegments(1) !== "details") {
            return;
        }

        $(() => { // Call after DOM Ready
            
            let model = window.Model;

            if (!model.DataModel) {
                return;
            }

            if (!model.DataModel.Items) {
                return;
            }

            // Inject structured data
            //let domain = GetDomain();
            //let catalog = [];

            let count = 0;
            model.DataModel.Items.forEach((product) => {
                //catalog.push(new SDProduct(product));
                product.UoMPrices.forEach((UoM) => { count++ });
            })

            model.DataModel.AccessoryItems.forEach((product) => {
                //    let item = new SDProduct(product);
                //    item.isAccessoryOrSparePartFor = domain + window.location.pathname;
                //    catalog.push(item);
                product.UoMPrices.forEach((UoM) => { count++ });
            })

            //let schema = new SDOfferCatalog();
            //schema.name = model.DataModel.Heading;
            //schema.url = domain + window.location.pathname;
            //schema.itemListElement = catalog;

            //new StructuredDataModelFactory().AddSchema(schema);            
            //new StructuredDataModelFactory().AddSchema(new SDProduct(model.DataModel.Items[0], count));
            
        })        

    }
}